var _rect, _rect2, _text, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 56,
    height: 48,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#333",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 48,
    height: 40,
    fill: "#0d0d0d"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 32,
    fontFamily: "Monaco, monospace",
    fontSize: 14,
    fill: "#00ff00"
  }, "&gt;_")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 22,
    width: 8,
    height: 14,
    fill: "#00ff00",
    opacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 56,
    y2: 16,
    stroke: "#00ff00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 56,
    y2: 20,
    stroke: "#00ff00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 24,
    x2: 56,
    y2: 24,
    stroke: "#00ff00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 28,
    x2: 56,
    y2: 28,
    stroke: "#00ff00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 32,
    x2: 56,
    y2: 32,
    stroke: "#00ff00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 36,
    x2: 56,
    y2: 36,
    stroke: "#00ff00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 40,
    x2: 56,
    y2: 40,
    stroke: "#00ff00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 44,
    x2: 56,
    y2: 44,
    stroke: "#00ff00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 48,
    x2: 56,
    y2: 48,
    stroke: "#00ff00",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.b7d438c3654f691ffbb78cfa99e22e84.svg";
export { ForwardRef as ReactComponent };